<section class="page_404">
    <div class="container-fluid">
      <div class="row "> 
      <div class=" ">
      <div class=" col-sm-offset-1  text-center">
      <div class="four_zero_four_bg">
        <h1 class="text-center "><span>404</span></h1>
      </div>
      
      <div class="contant_box_404">
      <h1 class="" [innerHTML]="this.h4Message" i18n>
        
      </h1>
      
      <p i18n>{{this.paragraphMessage}}</p>
      
      <a routerLink=".." class="link_404" i18n>{{this.buttonMessage}}</a>
    </div>
      </div>
      </div>
      </div>
    </div>
  </section>